import React, { useCallback, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks'
import { selectAccountId } from '../../../../../../store/auth/authSlice'
import { usePollingEffect } from '../../../common/hooks/usePollingEffect'
import { useLazyListRoomEventsQuery } from '../../../../../../store/media/media'
import { selectClientProfileEventPollingEnabled, setClientProfileEventsForPolling } from '../../../../../../store/meetingSummary/clientProfile'

export const ClientProfileEventPoller: React.FC = () => {
  const { roomId = '', sessionId = '' } = useParams()
  const accountId = useAppSelector(selectAccountId)

  usePollClientProfileEvents(accountId, roomId, sessionId)
  return null
}

const usePollClientProfileEvents = (accountId: string, roomId: string, sessionId: string) => {
  const dispatch = useAppDispatch()

  const [triggerGetRoomEvents] = useLazyListRoomEventsQuery()

  const clientProfileEventPollingEnabled = useAppSelector(selectClientProfileEventPollingEnabled)

  const getClientProfileEvents = useCallback(async () => {
    const { data: roomEvents } = await triggerGetRoomEvents({
      accountId,
      roomId,
      sessionId,
      pageRequest: { page: 0, size: 500 },
      types: ['aiFeatureExecutionFinished', 'userAllocationUpdated'],
    })
    if (!roomEvents?.data) {
      return
    }
    dispatch(setClientProfileEventsForPolling(roomEvents.data))
  }, [triggerGetRoomEvents, accountId, roomId, sessionId, dispatch])

  const { start: startClientProfileEventsPolling, stop: stopClientProfileEventsPolling } = usePollingEffect(getClientProfileEvents, [], {
    interval: 7000,
  })

  useEffect(() => {
    if (clientProfileEventPollingEnabled) {
      startClientProfileEventsPolling()
    } else {
      stopClientProfileEventsPolling()
    }
  }, [clientProfileEventPollingEnabled, startClientProfileEventsPolling, stopClientProfileEventsPolling])
}
